import React, { useEffect, useState } from "react";
import { getAll, postData } from "utils/queries";
import styles from "./notificationsPage.module.css"; // Import your CSS module
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate } from "react-router-dom";

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [count, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const navigate = useNavigate();

  const fetchNotifications = async () => {
    try {
      const results = await getAll(`notifications/notifications?offset=${offset}&limit=${limit}`);
      
      if (results) {
        const newNotifications = results?.data?.data?.rows?.map((e) => ({
          name: e?.first_name + " " + e?.last_name,
          ...e
        })) || [];
        
        setNotifications((prev) => [...prev, ...newNotifications]);
        setTotalCount(results?.data?.data?.count || 0);
        setOffset((prev) => prev + limit); // Update offset for next fetch
        
        // Update hasMore based on whether more data is available
        if (newNotifications.length < limit) {
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);



  const updateNotificationStatus = async(notification_id)=>{
    try {

        const result = await postData('notifications/notifications/user',{notification_id})
        
    } catch (error) {
        
    }
  }

  const navigateNotification = async (notification) => {
    let id = notification?.entity_id *1

    const result = await updateNotificationStatus(notification?.id)

    if(notification?.entity=="event"){
        navigate(`/event/event-details/${id}`)
    
    }else if(notifications?.entity=="ticlet"){
      navigate(`/ticket/ticket/edit-ticket/${id}`)
    }
  }

  return (
    <>
          <h1>All Notifications</h1>

    <div
      className={styles.notificationsPage}
      style={{ maxHeight: "80vh", overflow: "auto" }} // Ensure scrollable area
      id="scrollableDiv"
    >

      <InfiniteScroll
        dataLength={notifications.length}
        next={fetchNotifications}
        hasMore={hasMore}
        loader={<h4>Loading...</h4>}
        scrollableTarget="scrollableDiv"
      >
        {notifications.length ? (
          notifications.map((notification) => (
            <div key={notification.id} className={styles.notificationItem} onClick={()=>navigateNotification(notification)}>
              <div className={ notification?.read ? styles.notificationReadName :styles.notificationName}>{notification.first_name}</div>
              <p className={styles.message}>{notification.message}</p>
              <p>
                <strong>Created At:</strong> {new Date(notification.created_at).toLocaleString()}
              </p>
            </div>
          ))
        ) : (
          <div>No notifications</div>
        )}
      </InfiniteScroll>
    </div>
    </>

  );
};

export default Notifications;
